module.exports = __webpack_public_path__ + "static/img/0000智慧校园.bb528e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0000智慧校园.jpg
// module id = KmJY
// module chunks = 0